import { storeToRefs } from 'pinia';
import { computed, defineComponent, onMounted, ref } from 'vue';
import { SwitchPill } from '@yellowcard/components-library-vue3';
import BuyCryptoComponent from '@/components/buyCrypto/BuyCryptoComponent.vue';
import LoaderComponent from '@/components/general/LoaderComponent.vue';
import SellCryptoComponent from '@/components/sell/SellCryptoComponent.vue';
import router from '@/router';
import { useAuthStore } from '@/store/modules/auth';
import useTransactionsStore from '@/store/modules/transactions';
import { useInterceptorStore } from '@/store/modules/interceptor';
import { trackEvent, MIXPANEL_EVENTS } from '@/utils/mixpanel';
import { AuthTypes } from '@/types/auth';
import { TransactTypes } from '@/types/transact';
export default defineComponent({
    name: 'BuyHome',
    computed: {
        TransactTypes() {
            return TransactTypes;
        },
    },
    components: {
        SwitchPill,
        BuyCryptoComponent,
        SellCryptoComponent,
        LoaderComponent,
    },
    setup() {
        const authStore = useAuthStore();
        const { isLoggedIn, currentStep: authCurrentStep, standaloneAuthFlow, partnerId, sellEnabled, } = storeToRefs(authStore);
        const transactionsStore = useTransactionsStore();
        const { disableTransactionToggle, buyFlow } = storeToRefs(transactionsStore);
        const { showSideMenu, txType, selectedCurrencyAmount, selectedCryptoAmount, } = storeToRefs(transactionsStore);
        const interceptorStore = useInterceptorStore();
        const { loading } = storeToRefs(interceptorStore);
        onMounted(() => {
            trackEvent(MIXPANEL_EVENTS.SIGNIN.VIEW_HOME_SCREEN, {
                partner: partnerId.value,
            });
            buyFlow.value = false;
        });
        const showInput = ref(false);
        const signIn = () => {
            trackEvent(MIXPANEL_EVENTS.SIGNIN.SIGN_IN, {
                partner: partnerId.value,
            });
            router.push('/auth');
            authCurrentStep.value = AuthTypes.AuthSteps.AUTH_1;
            standaloneAuthFlow.value = true;
        };
        const onKeyPress = (event) => {
            event.preventDefault();
        };
        const openSideMenu = () => {
            showSideMenu.value = true;
        };
        const defaultTransactionType = computed(() => {
            if (txType.value === TransactTypes.TransactionType.BUY) {
                return 'Buy';
            }
            return 'Sell';
        });
        const onSwitchOptionSelected = async (evt) => {
            // reset input values
            if (selectedCryptoAmount.value.editable) {
                selectedCryptoAmount.value.amount = 0;
                selectedCurrencyAmount.value.amount = 0;
            }
            switch (evt.target.innerText) {
                case 'Buy':
                    txType.value = TransactTypes.TransactionType.BUY;
                    break;
                case 'Sell':
                    if (sellEnabled.value) {
                        txType.value = TransactTypes.TransactionType.SELL;
                    }
                    else {
                        await router.push('/sell');
                    }
                    break;
                default:
            }
        };
        const onBackClickListener = () => {
            router.push('/');
        };
        return {
            showInput,
            signIn,
            onKeyPress,
            isLoggedIn,
            openSideMenu,
            onSwitchOptionSelected,
            onBackClickListener,
            txType,
            defaultTransactionType,
            disableTransactionToggle,
            loading,
        };
    },
});
